var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13448_12746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 1H10.875C10.1125 1 9.38123 1.31607 8.84207 1.87868C8.3029 2.44129 8 3.20435 8 4V28C8 28.7956 8.3029 29.5587 8.84207 30.1213C9.38123 30.6839 10.1125 31 10.875 31H28.125C28.8875 31 29.6188 30.6839 30.1579 30.1213C30.6971 29.5587 31 28.7956 31 28V11.5L20.9375 1Z",
    stroke: "#94A3B8",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1V12H31",
    stroke: "#94A3B8",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24.1307,
    height: 11.8304,
    rx: 2.41307,
    fill: "#00A08B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.864 23H3L4.92 20.04L3.112 17.272H3.992L5.384 19.464H5.416L6.808 17.272H7.688L5.88 20.04L7.8 23H6.936L5.416 20.656H5.384L3.864 23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7187 23H8.50269V17.272H9.23869V22.296H11.7187V23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9031 23H12.0391L13.9591 20.04L12.1511 17.272H13.0311L14.4231 19.464H14.4551L15.8471 17.272H16.7271L14.9191 20.04L16.8391 23H15.9751L14.4551 20.656H14.4231L12.9031 23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 21.472C20.9996 21.9734 20.8156 22.376 20.4476 22.68C20.0743 22.9787 19.621 23.128 19.0876 23.128C18.613 23.128 18.1943 22.9894 17.8316 22.712C17.469 22.4347 17.2183 22.056 17.0796 21.576L17.7836 21.288C17.8316 21.4587 17.8983 21.6134 17.9836 21.752C18.069 21.8907 18.1676 22.0107 18.2796 22.112C18.397 22.208 18.525 22.2854 18.6636 22.344C18.8023 22.3974 18.949 22.424 19.1036 22.424C19.4396 22.424 19.7143 22.3387 19.9276 22.168C20.141 21.992 20.2476 21.76 20.2476 21.472C20.2476 21.232 20.1596 21.0267 19.9836 20.856C19.8183 20.6907 19.509 20.5307 19.0556 20.376C18.597 20.2107 18.3116 20.0987 18.1996 20.04C17.5916 19.7307 17.2876 19.2747 17.2876 18.672C17.2876 18.2507 17.4556 17.8907 17.7916 17.592C18.133 17.2934 18.5516 17.144 19.0476 17.144C19.485 17.144 19.8636 17.256 20.1836 17.48C20.5036 17.6987 20.717 17.9734 20.8236 18.304L20.1356 18.592C20.0716 18.3787 19.9436 18.2027 19.7516 18.064C19.565 17.92 19.3356 17.848 19.0636 17.848C18.7756 17.848 18.533 17.928 18.3356 18.088C18.1383 18.2374 18.0396 18.432 18.0396 18.672C18.0396 18.8694 18.117 19.04 18.2716 19.184C18.4423 19.328 18.813 19.4987 19.3836 19.696C19.965 19.8934 20.3783 20.136 20.6236 20.424C20.8743 20.7067 20.9996 21.056 20.9996 21.472Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13448_12746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxIcon);
export default __webpack_public_path__ + "static/media/xlsx_icon.6c1b41d93892ea4fa2d47b91b891e444.svg";
export { ForwardRef as ReactComponent };